import gql from 'graphql-tag'

export default gql`
  fragment operatorOrderInformation on Order {
    _id
    code
    description
    status
    activeProblems
    pointsNearAt
    currentPoint
    comment
    lastLog {
      _id
      message
    }
    points {
      name
    }
    shift {
      _id
      vehicle {
        _id
        type
        code
        completedOrdersCount
        firstName
        lastName
        categoryId
        approvedAt
      }
    }
    zone {
      _id
      name
    }
    givesPickerUses
  }
`
